
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import AppComponent from '../components/AppComponent';
import { getProfile, setProfileInitialized } from '../../profile/actions/ProfileActions';
import { enableTests } from '../actions/AppActions';
import { setStream } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state, ownProps) => ({
    jwt: state.profile.jwt,
    userIsPro: state.profile.user.isPro,
    params: queryString.parse(ownProps.location.search),
});

const mapDispatchToProps = (dispatch) => ({
    getProfile: () => {
        dispatch(getProfile());
    },
    enableTests: (enabledTests) => {
        dispatch(enableTests(enabledTests));
    },
    setStream: (streamId, userInitiated) => {
        dispatch(setStream(streamId, userInitiated));
    },
    setProfileInitialized: () => {
        dispatch(setProfileInitialized());
    },
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(AppComponent));
